const yourls = require('yourls-api')
const sptfy = yourls.connect('https://sptfy.be/yourls-api.php', {
    username: 'joshua',
    password: 'uJo@&qX@',
    format: 'json'
})

export default sptfy;